import React from 'react'
import "./passive.scss";
import ba_bg from "../../img/banner.jpg";

const Passive = () => {
  return (
    <div
      className="passive_wrp"
      style={{
        backgroundImage: `linear-gradient(90deg, rgba(2, 0, 36, 0.65) 0%, rgba(9, 9, 121, 0.4) 35%, rgba(0, 212, 255, 0) 100%), url(${ba_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="pass_lft">
        <div>
          <h4>
            Passive Income Made Simple <em>Focus on What Matters</em>{" "}
          </h4>
          <span>
            <em>
              With Intellitech, generating passive income is no longer a
              dream—it’s a discipline powered by innovation.
            </em>{" "}
            Our AI-driven <em>“Auto Trade”</em> algorithm executes trades in
            real time with precision, freeing you from the stress of constant
            market monitoring. You maintain full visibility over your positions,
            statements, and balances, while enjoying consistent, proven results
            that outperform manual trading. <br />
            <br />
            Delivered through our intuitive mobile app and Telegram alerts,
            IntelliTech gives you the freedom to save time, eliminate emotional
            decision-making, and stay informed—without sacrificing convenience
            or security. Backed by dedicated account management and 24/7
            support, Intellitech empowers you to trade smarter, live better, and
            let your money work for you.
          </span>
        </div>

        <br />

        <div className="btn_wrp">
          <button className="btn">Contact Team</button>
          {/* <button className="btn_out">Explore</button> */}
        </div>
      </div>
      <div className="pass_rgt">
        <div class="trading-visual">
          <div class="data-point" style={{ top: "55%", left: "30%" }}>
            <small>25.6</small>
          </div>
          <div class="data-point" style={{ top: "30%", left: "55%" }}>
            <small>34.8</small>
          </div>
          <div class="data-point" style={{ top: "60%", left: "75%" }}>
            <small>26.09</small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Passive
